import React, { useState } from 'react';
import { func, number, bool } from 'prop-types';
import { noop } from 'lodash';
import { Variation, FavoriteButton, hasCurvedText } from '@fiverr-private/variations_display';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import { USER_SAVING_ACTIONS } from '../../../Listing/constants';
import { reportAddToFavoritesClick } from '../../../../../shared/reportEvents/bigQuery';
import { TRACKING_PAGE_NAMES } from '../../../../../service/bigquery';
import { useChooseVariationContext } from '../../Context';
import Navigation from '../../Navigation';
import { useFavoritesContext } from '../../FavoritesContext';
import './style.scss';

const { reportAddToFavorites, reportRemoveFromFavorites } = makersExperience.chooseVariation;

const { Location } = reportAddToFavorites;

const MainSample = ({ variationIndex, onTextFieldsRender = noop, onPurchase = noop, isLoading }) => {
    const { addToFavorites, removeFromFavorites, isFavorite } = useFavoritesContext();
    const [isRendered, setIsRendered] = useState(false);
    const { selectedVariation, projectId, userId } = useChooseVariationContext();
    const [isSaving, setIsSaving] = useState(false);

    const createUserSaving = async () => {
        reportAddToFavorites(variationIndex + 1, Location.VARIATIONS);
        await addToFavorites();
    };

    const removeUserSaving = async () => {
        reportRemoveFromFavorites(variationIndex + 1, Location.VARIATIONS);
        removeFromFavorites();
    };

    const onUserSavingChange = async (isFavorite) => {
        if (isSaving) {
            return false;
        }

        setIsSaving(true);

        isFavorite ? await createUserSaving() : await removeUserSaving();

        reportAddToFavoritesClick({
            projectId,
            variationId: selectedVariation.id,
            type: isFavorite ? USER_SAVING_ACTIONS.ADD : USER_SAVING_ACTIONS.REMOVE,
            pageName: TRACKING_PAGE_NAMES.CHOOSE_VARIATION,
        });

        setIsSaving(false);
        return true;
    };

    const onTextFieldsRenderTick = () => {
        onTextFieldsRender();
        setIsRendered(true);
    };

    return (
        <div className="chosen-variation">
            <Variation
                key={selectedVariation.id}
                {...selectedVariation}
                applyVerticalChanges={!hasCurvedText(selectedVariation)}
                onTextFieldsRenderTick={onTextFieldsRenderTick}
                withWatermark={true}
            />

            <div className="logo-project-card favorite-container actions">
                {!!userId && <FavoriteButton isFavorite={isFavorite} onChange={onUserSavingChange} />}
                {!!isRendered && (
                    <div className="chosen-variation-navigation">
                        <Navigation isDisabled={!isRendered} isLoading={isLoading} onPurchase={onPurchase} />
                    </div>
                )}
            </div>
        </div>
    );
};

MainSample.propTypes = {
    variationIndex: number,
    onTextFieldsRender: func,
    onPurchase: func,
    isLoading: bool,
};

export default MainSample;
